export const ArrowUpIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none">
    <g id="vuesax/outline/arrow-up">
      <g id="arrow-up">
        <path
          id="Vector"
          d="M11.6204 9.21688C11.5095 9.21688 11.3987 9.17604 11.3112 9.08854L7.50788 5.28521C7.22788 5.00521 6.77288 5.00521 6.49288 5.28521L2.68954 9.08854C2.52038 9.25771 2.24038 9.25771 2.07121 9.08854C1.90204 8.91938 1.90204 8.63938 2.07121 8.47021L5.87454 4.66688C6.49288 4.04854 7.50205 4.04854 8.12621 4.66688L11.9295 8.47021C12.0987 8.63938 12.0987 8.91938 11.9295 9.08854C11.842 9.17021 11.7312 9.21688 11.6204 9.21688Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
